import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/lib/i18n";

const empty = { name: "", email: "", phone: "", message: "" };

export const InquireDialog = ({ open, onOpenChange, type, subject }) => {
  const { t } = useLang();
  const [form, setForm] = useState(empty);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/inquiries", { ...form, type, subject });
      toast.success(t("inq.ok"));
      setForm(empty);
      onOpenChange(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="inquire-dialog" className="bg-[var(--ink-2)] border-[var(--line)] rounded-none max-w-lg">
        <DialogHeader>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[var(--signal)]">{t("inq.kicker")}</p>
          <DialogTitle className="font-display text-4xl font-black uppercase leading-none">{subject}</DialogTitle>
          <DialogDescription className="text-[var(--muted)]">{t("inq.desc")}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-5 mt-2">
          <div className="grid sm:grid-cols-2 gap-5">
            <label className="block"><span className="field-label">{t("f.name")}</span>
              <input data-testid="inquire-name-input" required className="field" value={form.name} onChange={set("name")} /></label>
            <label className="block"><span className="field-label">{t("f.phone")}</span>
              <input data-testid="inquire-phone-input" className="field" value={form.phone} onChange={set("phone")} /></label>
          </div>
          <label className="block"><span className="field-label">{t("f.email")}</span>
            <input data-testid="inquire-email-input" required type="email" className="field" value={form.email} onChange={set("email")} /></label>
          <label className="block"><span className="field-label">{t("f.message")}</span>
            <textarea data-testid="inquire-message-input" rows={3} className="field resize-none" value={form.message} onChange={set("message")}
              placeholder={t("inq.placeholder")} /></label>
          <button data-testid="inquire-submit-button" disabled={busy}
            className="w-full clip-cut-sm bg-[var(--signal)] text-[var(--ink)] font-mono text-xs uppercase tracking-[0.25em] py-4 hover:bg-[var(--bone)] transition-colors disabled:opacity-60">
            {busy ? t("inq.sending") : t("inq.send")}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
